import { render, staticRenderFns } from "./calendarDayItem.vue?vue&type=template&id=639c0cad&scoped=true&"
import script from "./calendarDayItem.vue?vue&type=script&lang=js&"
export * from "./calendarDayItem.vue?vue&type=script&lang=js&"
import style0 from "./calendarDayItem.vue?vue&type=style&index=0&id=639c0cad&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639c0cad",
  null
  
)

export default component.exports